<template>
  <MAFieldWrapper
    :type="type"
    :label="label"
    :value="value"
    :disabled="disabled"
    :required="required"
    :readonly="readonly"
    :placeholder="placeholder"
    :rules="rules"
  >
    <template #default="{ validator, handleBlur }">
      <component
        :is="InputVariant"
        :id="id"
        v-model="value"
        :type="type"
        :invalid="validator?.$dirty && validator?.$invalid"
        :disabled="disabled"
        :autofocus="autofocus"
        :placeholder="placeholder"
        class="w-full"
        @blur="onBlur(handleBlur)"
      />
    </template>
  </MAFieldWrapper>
</template>

<script setup lang="ts">
import MAFieldWrapper from "@/components/primevueComponents/MAFieldWrapper.vue";
import type { AnyFn } from "@vueuse/core";
import InputText from "@/volt/InputText.vue";
import SoftInput from "@/volt/SoftInput.vue";
import { ulid } from "ulid";

const props = withDefaults(
  defineProps<{
    type?: "email" | "text" | "phone" | "url" | "password";
    label?: string;
    id?: string;
    modelValue?: string;
    disabled?: boolean;
    required?: boolean;
    readonly?: boolean;
    placeholder?: string;
    autofocus?: boolean;
    rules?: Record<string, any>;
    variant?: "default" | "soft";
  }>(),
  {
    id: ulid(),
    disabled: false,
    placeholder: "",
    modelValue: "",
    type: "text",
    rules: () => ({}),
    variant: "default",
  }
);

const InputVariant = computed(() => {
  return props.variant === "soft" ? SoftInput : InputText;
});

const emit = defineEmits(["update:modelValue", "blur"]);
const value = useVModel(props, "modelValue", emit);

function onBlur(cb?: AnyFn) {
  if (cb) cb();
  emit("blur");
}
</script>
